import { render, staticRenderFns } from "./Refund_detail.vue?vue&type=template&id=67686226&scoped=true&"
import script from "./Refund_detail.vue?vue&type=script&lang=js&"
export * from "./Refund_detail.vue?vue&type=script&lang=js&"
import style0 from "./Refund_detail.vue?vue&type=style&index=0&id=67686226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67686226",
  null
  
)

export default component.exports